// Function to make IE9+ support forEach:
// https://stackoverflow.com/questions/44652092/ie-doesnt-support-foreach-even-with-polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// String.prototype.replaceAll() polyfill support for IE
// https://gomakethings.com/how-to-replace-a-section-of-a-string-with-another-one-with-vanilla-js/

if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function(str, newStr){

    // If a regex pattern
    if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
      return this.replace(str, newStr);
    }

    // If a string
    return this.replace(new RegExp(str, 'g'), newStr);

  };
}